"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckoutGodMode = exports.CheckoutGodModeProvider = void 0;
var _react = require("react");
var _models = require("../models");
const checkoutGodModeContext = /*#__PURE__*/(0, _react.createContext)({
  data: [],
  filter: _models.GodModeRowFiltering.all,
  setFilter: () => {},
  filterCounts: {
    [_models.GodModeRowFiltering.all]: 0,
    [_models.GodModeRowFiltering.qualified]: 0,
    [_models.GodModeRowFiltering.used]: 0,
    [_models.GodModeRowFiltering.error]: 0
  }
});
const CheckoutGodModeProvider = exports.CheckoutGodModeProvider = checkoutGodModeContext.Provider;
const useCheckoutGodMode = () => (0, _react.useContext)(checkoutGodModeContext);
exports.useCheckoutGodMode = useCheckoutGodMode;